var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-input',{attrs:{"validation":_vm.validation,"label":_vm.label,"stacked":_vm.stacked,"no-line":_vm.noLine,"notes":_vm.notes}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }